// Oturum çerezi (madde 17) için merkezi fetch sarmalayıcısı — uygulamanın HTTP "istemcisi".
//
// Token artık JavaScript'te YOK: backend ts_access / ts_refresh HttpOnly çerezlerini kendisi
// koyar. Bu sarmalayıcı /api isteklerinde:
//   - credentials: 'same-origin' (çerez gider) + X-Requested-With (backend CSRF kontrolü),
//   - bileşenlerin eskiden eklediği "Authorization: Bearer …" başlığını kaldırır (token yok),
//   - 401'de bir kez /api/auth/refresh deneyip isteği tekrarlar; eşzamanlı istekler aynı
//     yenilemeyi bekler. Yenileme de başarısızsa 401 olduğu gibi döner (App.js çıkış yapar).
// Giriş/2FA/yenileme uçları yenileme denemesinden hariç (yanlış şifrede kullanıcı atılmasın).

// Bileşenlerin "oturum var" işareti olarak taşıdığı değer (gerçek token değil).
export const SESSION_MARKER = 'cookie';

const NO_REFRESH = [
  '/api/auth/login', '/api/auth/register', '/api/auth/refresh', '/api/auth/logout',
  '/api/auth/2fa/verify', '/api/auth/2fa/resend',
];

let origFetch = null;
let refreshing = null;

export function refreshSession() {
  if (!refreshing) {
    refreshing = (origFetch || window.fetch)('/api/auth/refresh', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((r) => r.ok)
      .catch(() => false)
      .finally(() => { setTimeout(() => { refreshing = null; }, 0); });
  }
  return refreshing;
}

function apiPath(input) {
  const url = typeof input === 'string' ? input : input?.url || '';
  if (url.startsWith('/')) return url;
  if (url.startsWith(window.location.origin + '/')) return url.slice(window.location.origin.length);
  return null;
}

export function installApiFetch() {
  if (origFetch) return;
  origFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const path = apiPath(input);
    if (!path || !path.startsWith('/api/')) return origFetch(input, init);
    const build = () => {
      const headers = new Headers(init.headers || undefined);
      if ((headers.get('Authorization') || '').startsWith('Bearer ')) headers.delete('Authorization');
      headers.set('X-Requested-With', 'XMLHttpRequest');
      return { ...init, headers, credentials: 'same-origin' };
    };
    let res = await origFetch(input, build());
    if (res.status === 401 && !NO_REFRESH.some((p) => path.startsWith(p))) {
      if (await refreshSession()) res = await origFetch(input, build());
    }
    return res;
  };
}
